import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  DateRangeQuery,
  Error,
  GetTestCaseSummaryResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  params?: DateRangeQuery
  onError?: (error: Error) => void
  onSuccess?: (data: GetTestCaseSummaryResponse[]) => void
  children?: (data: GetTestCaseSummaryResponse[]) => ReactElement
}

const GetAiModelTestCasesSummary = ({
  id,
  params,
  onError,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/models/${id}/testcasesummary`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default GetAiModelTestCasesSummary
